import React from 'react';
import { Typography } from '@mui/material';

function ReportDescription() {
  return (
    <Typography variant="body2" className="report-description">
      Download a formal notice for the selected client identifying units across all buildings that
      missed two scheduled XRF inspections due to denied access.
    </Typography>
  );
}

export default ReportDescription; 